import React, { useState } from 'react'
import SignupLoginImage from '../../component/signup-image/SignupLoginImage'
import { CircularProgress, IconButton, InputAdornment, OutlinedInput, TextField, Typography } from '@mui/material'
import "./resetpassword.css"
import { Email, Visibility, VisibilityOff } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom';
import GenerateOtp from '../../Apis/GenerateOtp'
import { toast, ToastContainer } from 'react-toastify'
import VerifyOtp from '../../Apis/VerifyOtp'
import updatePassword from '../../Apis/UpdatePassword'

const ResetPassword = () => {
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [userGivenDetails, setUserGivenDetails] = useState({
        email: "",
        onetimepassword: "",
        otpsent: false,
        otpverified: false,
        password: "",
        confirmPassword: "",
        emailverificationId: "",
        userId: ""
    })
    const [buttonLoader, setButtonLoader] = useState({
        sendOtpLoader: false,
        verifyOtpLoader: false,
        updatePasswordLoader: false
    })

    const navigate = useNavigate();

    const handleLoginPage = () => {
        navigate('/')
    }

    const handleOtpSend = async () => {
        try {
            if (userGivenDetails.email === '') {
                toast.error('Please enter your email')
                return
            }
            setButtonLoader({ ...buttonLoader, sendOtpLoader: true })
            let payload = {
                email: userGivenDetails.email,
                isAccountCreate: false,
                isPasswordReset: true
            }
            let response = await GenerateOtp(payload)
            if (response.status === 200) {
                setButtonLoader({ ...buttonLoader, sendOtpLoader: false })
                setUserGivenDetails({ ...userGivenDetails, otpsent: true, emailverificationId: response?.data?.id })
            }
            else {
                let errMessage = response?.response?.data?.detail || 'Something went wrong'
                toast.error(errMessage)
                setButtonLoader({ ...buttonLoader, sendOtpLoader: false })
            }
        } catch (error) {
            toast.error('Something went wrong')
            console.log(error)
            setButtonLoader({ ...buttonLoader, sendOtpLoader: false })
        }
    }

    const handleOtpVerify = async () => {
        try {
            if (userGivenDetails.onetimepassword === '') {
                toast.error('Please enter the OTP')
                return
            }
            setButtonLoader({ ...buttonLoader, verifyOtpLoader: true })
            let payload = {
                emailverificationId: userGivenDetails.emailverificationId,
                otp: userGivenDetails.onetimepassword
            }
            let response = await VerifyOtp(payload)
            if (response.status === 200) {
                setButtonLoader({ ...buttonLoader, verifyOtpLoader: false })
                setUserGivenDetails({ ...userGivenDetails, otpverified: true, userId: response?.data?.userId })
            }
            else {
                toast.error('Invalid OTP')
                setButtonLoader({ ...buttonLoader, verifyOtpLoader: false })
            }
        } catch (error) {
            toast.error('Something went wrong')
            console.log(error)
            setButtonLoader({ ...buttonLoader, verifyOtpLoader: false })
        }
    }

    const handleUpdatePassword = async () => {
        try {
            if (userGivenDetails.password === '' || userGivenDetails.confirmPassword === '') {
                toast.error('Please enter the password')
                return
            }
            if (userGivenDetails.password !== userGivenDetails.confirmPassword) {
                toast.error('Password and confirm password should be same')
                return
            }
            setButtonLoader({ ...buttonLoader, updatePasswordLoader: true })
            let payload = {
                userId: userGivenDetails.userId,
                password: userGivenDetails.password
            }
            let response = await updatePassword(payload)
            if (response.status === 200) {
                setButtonLoader({ ...buttonLoader, updatePasswordLoader: false })
                toast.success('Password updated successfully')
                setUserGivenDetails({
                    email: "",
                    onetimepassword: "",
                    otpsent: false,
                    otpverified: false,
                    password: "",
                    confirmPassword: "",
                    emailverificationId: "",
                    userId: ""
                })
                navigate('/')
            }
            else{
                toast.error('Unable to update password')
                setButtonLoader({ ...buttonLoader, updatePasswordLoader: false })
            }
        } catch (error) {
            toast.error('Something went wrong')
            setButtonLoader({ ...buttonLoader, updatePasswordLoader: false })
            console.log(error)
        }

    }

    return (
        <>
            <div className='signup-page'>
                <SignupLoginImage />
                <div className='signup-Div'>
                    <div className='resetPasswordCard'>
                        <div className='resetPasswordTitle'>Reset your password</div>
                        <div className='inputFieldsContainer'>
                            <span>Email*</span>
                            <OutlinedInput
                                placeholder='Enter your email address'
                                value={userGivenDetails.email}
                                disabled={userGivenDetails.otpsent}
                                onChange={(e) => setUserGivenDetails({ ...userGivenDetails, email: e.target.value })}
                            />
                        </div>
                        <button
                            className='sendOtpButton'
                            onClick={() => handleOtpSend()}
                            disabled={userGivenDetails.otpsent}
                        >
                            {buttonLoader.sendOtpLoader && <CircularProgress className='circularPg_resetpsw' size={30} />}
                            {userGivenDetails.otpsent && (
                                <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                    <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                                </svg>
                            )}
                            {buttonLoader.sendOtpLoader ? <span>Sending OTP</span> :
                                <span>{userGivenDetails.otpsent ? "OTP Sent" : "Send OTP"}</span>
                            }
                        </button>

                        <div className='inputFieldsContainer'>
                            <span>Verification Code</span>
                            <div className='verificationFieldContainer'>
                                <TextField
                                    placeholder="Enter 6 digit Code"
                                    disabled={!userGivenDetails.otpsent || userGivenDetails.otpverified}
                                    value={userGivenDetails.onetimepassword}
                                    onChange={(e) => {
                                        const value = e.target.value.slice(0, 6);
                                        if (/^\d*$/.test(value)) {
                                            setUserGivenDetails({ ...userGivenDetails, onetimepassword: value });
                                        }
                                    }}
                                    type="number"
                                    inputProps={{ maxLength: 6 }}
                                />
                                <button
                                    className='verifyButton'
                                    disabled={!userGivenDetails.otpsent || userGivenDetails.otpverified}
                                    onClick={() => handleOtpVerify()}
                                >
                                    {buttonLoader.verifyOtpLoader && <CircularProgress className='circularPg_resetpsw' size={30} />}
                                    {userGivenDetails.otpverified && (
                                        <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                                            <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                                        </svg>
                                    )}
                                    {buttonLoader.verifyOtpLoader ? <span>Verifying OTP</span> :
                                        <span>{userGivenDetails.otpverified ? "Verified" : "Verify"}</span>
                                    }
                                </button>
                            </div>

                        </div>

                        <div className='inputFieldsContainer'>
                            <span>New Password*</span>
                            <OutlinedInput
                                placeholder='Enter your password...'
                                className='passwordInput'
                                disabled={!userGivenDetails.otpverified}
                                type={showPassword ? 'text' : 'password'}
                                value={userGivenDetails.password}
                                onChange={(e) => setUserGivenDetails({ ...userGivenDetails, password: e.target.value })}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={showPassword ? 'hide the password' : 'display the password'}
                                            onClick={() => setShowPassword(!showPassword)}
                                            edge="end"
                                            disabled={!userGivenDetails.otpverified}
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </div>
                        <div className='inputFieldsContainer'>
                            <span>Confirm New Password*</span>
                            <OutlinedInput
                                placeholder='Enter your password...'
                                className='passwordInput'
                                disabled={!userGivenDetails.otpverified}
                                type={showConfirmPassword ? 'text' : 'password'}
                                value={userGivenDetails.confirmPassword}
                                onChange={(e) => setUserGivenDetails({ ...userGivenDetails, confirmPassword: e.target.value })}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label={showConfirmPassword ? 'hide the password' : 'display the password'}
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            edge="end"
                                            disabled={!userGivenDetails.otpverified}
                                        >
                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                        </IconButton>
                                    </InputAdornment>
                                }
                            />
                        </div>

                        <button
                            className='updatePasswordButton'
                            onClick={() => handleUpdatePassword()}
                            disabled={!userGivenDetails.otpverified}
                        >
                            {buttonLoader.updatePasswordLoader && <CircularProgress className='circularPg_resetpsw' size={30} />}
                            {buttonLoader.updatePasswordLoader ? <span>Updating Password</span> : <span>Update Password</span>}
                        </button>

                        <div className='loginNoAccountMessageContainer'>
                            <span onClick={(e) => handleLoginPage()} className='signup_login'>back to login page</span>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default ResetPassword